<app-base-page-template>
  <app-base-page-content-template>
    <app-chart-of-accounts-grid
      (rowClick)="onRowClicked($event)"
      (addButtonClick)="onAddButtonClicked()">
    </app-chart-of-accounts-grid>
  </app-base-page-content-template>
</app-base-page-template>
